
export const reloadCart = ({apis}) => ({
    action: async (cart) => {
        const resultCart = await apis.next.cart.validateCart(cart.cartId);
        return {
            change: () => resultCart,
        };
    },
});


